
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ScrollTracking label='content25' mdxType="ScrollTracking" />
    <h4>Von Kolumbien ins Baselbiet</h4>
    <p>
 In einem Kinderheim lebte einst auch auch William W. Er kam 1973 in der kolumbianischen Grossstadt Medellín zur Welt. Die Mutter 
 starb bald nach der Geburt. Danach kam der Bub weg von seinem Vater und landete im Kinderheim. Schliesslich adoptierte ein Ehepaar 
 den Achtjährigen, holte ihn ins Baselbiet.
  <Image file={require('images/kinderfotos.png')} source='W. erlebte in Kolumbien eine schwierige Kindheit. (RD)' mdxType="Image" />
    </p>
    <p>
In der Schweiz hat W. Mühe, sich zu binden, persönliche Beziehungen einzugehen. Statt zu arbeiten, gerät er früh auf die schiefe 
Bahn. Als 19-Jähriger hat er schon etliche Delikte begangen. Das Strafgericht Basel-Stadt verurteilt ihn 1993 wegen mehrfachem Raub,
 Diebstahl, Sachbeschädigung und verschiedenen Verkehrsdelikten. Ein gutes Jahr beträgt die Gefängnisstrafe. Die Richter sprechen 
 sie bedingt aus - der Teenager soll eine Chance erhalten, sich zu bewähren.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;